import { useScreenSize } from '~/src/common/hooks/useScreenSize';
import I18n from '~/src/common/services/I18n/I18n';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';
import { useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';
import {
  Navigation200FamiliesItem,
  Navigation200FamiliesItemCategoriesItem,
} from '~/src/queries/api-ecom/generated/api-ecom.schemas';

const SeoFamilyCategory = (props: {
  category: Navigation200FamiliesItemCategoriesItem;
  withChildren: boolean;
}) => {
  return (
    <div>
      <a key={props.category.id} href={`/categorie/${props.category.slug}`}>
        <img
          src={getImageUrl(props.category.image, ImageParams.familyCategory)}
          alt={props.category.name}
        />
        <span>{props.category.name}</span>
        {props.category.label && <span>{props.category.label.text}</span>}
      </a>

      {props.withChildren && (
        <>
          <ul>
            {props.category.children.map(sub => (
              <li key={sub.id}>
                <a href={`/categorie/${sub.slug}`}>{sub.name}</a>
                {sub.label && <span>{sub.label.text}</span>}
              </li>
            ))}
          </ul>

          <a href={`/categorie/${props.category.slug}`}>
            <span>{I18n.t('common.see-all')}</span>
          </a>
        </>
      )}
    </div>
  );
};

const SeoFamilyCategories = (props: {
  family: Navigation200FamiliesItem;
  withChildren: boolean;
}) => {
  return (
    <div>
      {props.family.categories.map(category => (
        <SeoFamilyCategory
          withChildren={props.withChildren}
          key={category.id}
          category={category}
        />
      ))}
    </div>
  );
};

const SeoFamily = (props: { family: Navigation200FamiliesItem; withChildren: boolean }) => {
  const link = props.family.link || '#';
  const imgSrc = props.family.images.aside
    ? getImageUrl(props.family.images.aside, ImageParams.familyAside)
    : null;

  return (
    <div>
      {imgSrc != null && (
        <a href={link} aria-disabled={link === '#'}>
          <img src={imgSrc} alt={props.family.name} />
        </a>
      )}

      <SeoFamilyCategories withChildren={props.withChildren} family={props.family} />
    </div>
  );
};
export const SeoFamillies = () => {
  const { data } = useNavigation();
  const screen = useScreenSize();

  if (data == null) return null;

  const SeoCategories = screen.isLargeScreen ? SeoFamily : SeoFamilyCategories;

  return (
    <nav style={{ display: 'none' }}>
      {data.families.map(family => (
        <div key={family.id} className={`menu-family-${family.id}`}>
          <div>{family.name}</div>
          <SeoCategories family={family} withChildren={screen.isLargeScreen} />
        </div>
      ))}
    </nav>
  );
};
